import { Textarea, TextareaProps} from "@chakra-ui/react";
import {BaseControl, BaseControlProps} from "../BaseControl";

interface BaseTextAreaProps
    extends BaseControlProps, TextareaProps{
}

export const BaseTextArea = (props: BaseTextAreaProps) => {
    const {name, fieldTitle, ...extra} = props;

    return (
        <BaseControl {...extra} fieldTitle={fieldTitle}>
            <Textarea
                {...props}
                outline="none"
                border="1px solid"
                borderColor="#E2E8F0"
                borderRadius="lg"
                bgColor="white"
                maxW="100%"
                name={name}
                onChange={props.onChange}
                fontSize="sm"
                _hover={{
                    borderColor: "blue.400",
                    boxShadow: "sm"
                }}
                _focus={{
                    borderColor: "blue.500",
                    boxShadow: "0 0 0 1px #3182ce",
                    outline: "none"
                }}
                transition="all 0.2s"
                _placeholder={{
                    color: "gray.400"
                }}
            />
        </BaseControl>
    );
};
